import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets the data for ManagePaidAmounts screen.
 * @param {number} campaignId
 */
export default async ({ campaignId }) => {
  const query = `query 
  ($campaignId:ID!) {
      campaign(id:$campaignId){
        country{
          currencySign
        }
        cityPlans {
          nodes {
            id
            city {
              id
              name
            }
            missions {
              edges {
                node {
                  id
                  status
                  cancelled
                  dateTime
                }
              }
            }
            permitCosts {
              nodes {
                startDate
                cost
              }
            }
          }
        }
      }
    }`

  return await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}
